class Analytics {
  constructor(ctx) {
    this.ctx = ctx
  }

  getTrackData() {
    return [
      {
        eventCategory: '',
        eventAction: '',
        eventLabel: '',
        event: ''
      }
    ]
  }

  trackEvent(type, payload) {
    const events = {}
    const objSchema = this.getTrackData()
    const ctx = this.ctx
    try {
      const trackData = (events[type] || events.default)({ objSchema, payload, ctx })
      this.sendTrack(trackData)
    } catch (error) {
      console.log('Error Analytics type: ' + type + ' Error', error)
    }
  }

  sendTrack = (trackData) => {
    window.utag.link(trackData)
  }
}

export default (ctx, inject) => {
  inject('Analytics', new Analytics(ctx))
}
